import React, { useState, useEffect } from 'react';
import fetch from 'isomorphic-fetch';
import IconClose from '@/icons/icon-close.svg';
import IconError from '@/icons/error-icon.svg';
import { useKlaviyoApi } from '../../hooks/useKlaviyoApi';

export function BackInStockModal({ selectedVariant, product }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const { backInStockSubscription } = useKlaviyoApi();

  const handleClick = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setLoading(true);

    const variant = selectedVariant.legacyResourceId;

    try {
      await backInStockSubscription({
        email,
        variantId: variant,
        callback: (response) => {
          if(response == 'success') {
            const successMessage =
              'Success! We\'ll notify you when this product is in stock. We don\'t share your address with anybody else.';
            setMessage(successMessage);
            setEmail('');
          } else {
            setMessage('Uh something went wrong');
          }
          setLoading(false);
        }
      })
    } catch (error) {
      console.log(error);
      setMessage('Uh something went wrong');
      setLoading(false);
    }
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setEmail('');
    setIsOpen(false);
  };

  useEffect(() => {
    document.addEventListener('backInStockModal:open', openModal);
    return () => {
      document.removeEventListener('backInStockModal:open', openModal);
    };
  });

  if (!selectedVariant) return null;

  return (
    <div
      className={`BackInStockModal fixed top-0 left-0 z-[100000] flex h-full w-full items-center justify-center ${
        isOpen
          ? 'pointer-events-auto opacity-100'
          : 'pointer-events-none opacity-0'
      }`}
    >
      <div
        className="modal-body relative z-[101] mx-auto max-h-[80%] w-[1200px] max-w-[80%] overflow-y-auto bg-white p-4"
        style={{
          width: '660px',
          maxWidth: '90%',
          textAlign: 'center',
          paddingBottom: '30px',
        }}
      >
        <div className="modal-header w-full text-right">
          <button
            type="button"
            className="backInStockModalClose"
            onClick={closeModal}
            aria-label="back In Stock modal close"
          >
            <IconClose />
          </button>
          {true && (
            <div
              className="modal-body-content gap-6"
              style={{ textAlign: 'center', margin: 'auto' }}
            >
              <div>
                <h3 className="mb-0 text-center text-h5 font-light md:text-h3">
                  Email Me When Available
                </h3>
                <p
                  style={{
                    display: 'block',
                    textAlign: 'center',
                    my: 15,
                    maxWidth: '300px',
                    margin: '15px auto',
                    color: '#000000',
                    fontSize: '14px',
                    marginBottom: '36px',
                  }}
                >
                  Register your email address below to receive an email as soon
                  as this becomes available again.
                </p>

                <div
                  style={{
                    alignItems: 'baseline',
                    mx: 'auto',
                    maxWidth: '660px',
                    gridGap: '15px',
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                  }}
                >
                  <input
                    type="email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    placeholder="Email Address"
                    aria-label="Email Address"
                    style={{
                      border: '1px solid #979797',
                      maxWidth: '430px',
                      width: '100%',
                      margin: 'auto',
                      padding: '12px 20px',
                      outline: 'none',
                      '::placeholder': {
                        color: '#000000',
                      },
                    }}
                  />

                  <button
                    type="button"
                    aria-label="Submit Back In Stock"
                    className="button button--primary mt-5 block flex w-full justify-center"
                    style={{
                      maxWidth: '430px',
                      width: '100%',
                      margin: 'auto',
                    }}
                    disabled={loading}
                    onClick={handleClick}
                  >
                    email me when available
                  </button>
                </div>

                <div
                  style={{
                    textAlign: 'left',
                    marginTop: 20,
                    fontSize: '14px',
                    paddingBottom: 0,
                    marginBottom: 0,
                    maxWidth: '430px',
                    width: '100%',
                    margin: '24px auto 0px auto',
                    display: 'grid',
                    gridTemplateColumns: 'auto 1fr',
                    gridGap: '10px',
                  }}
                >
                  {message?.includes('Success') && (
                    <img
                      src="/images/success-icon.png"
                      style={{ width: '16px', marginTop: '3px' }}
                      alt="success icon"
                      width="16"
                      height="16"
                    />
                  )}

                  {message && !message?.includes('Success') && (
                    <IconError style={{ marginTop: '3px' }} />
                  )}

                  <p
                    style={{
                      color: message?.includes('Success')
                        ? '#218246'
                        : '#e23f3f',
                    }}
                  >
                    {message}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <button
        type="button"
        className={`modalBackdrop z-103 fixed top-0 left-0 h-full w-full cursor-pointer bg-black ${
          isOpen ? 'pointer-events-auto opacity-50' : 'opacity-0'
        }`}
        onClick={closeModal}
      >
        <span className="sr-only">Close Quick View</span>
      </button>
    </div>
  );
}

export default BackInStockModal;
